import type { ListFiltersRequest } from '@/Network/Types/Requests/StationRequests'

export type SectorSpecialtyChip = {
  key: string
  text: string
  kind: 'sector' | 'no-sector' | 'official' | 'company' | 'no-specialty'
  value: string | null
}

type Names = { sector: (id: number) => string | null; specialty: (key: string) => string | null }

export function buildSectorSpecialtyChips(
  query: ListFiltersRequest,
  names: Names
): SectorSpecialtyChip[] {
  const chips: SectorSpecialtyChip[] = []
  ;(query.sectorIds ?? []).forEach((id) =>
    chips.push({
      key: `s:${id}`,
      text: `Setor: ${names.sector(Number(id)) ?? `#${id}`}`,
      kind: 'sector',
      value: id
    })
  )
  if (query.withoutSector)
    chips.push({ key: 's:none', text: 'Sem setor', kind: 'no-sector', value: null })
  ;(query.specialtyIds ?? []).forEach((id) =>
    chips.push({
      key: `o:${id}`,
      text: `Especialidade: ${names.specialty(`o:${id}`) ?? `#${id}`}`,
      kind: 'official',
      value: id
    })
  )
  ;(query.companySpecialtyIds ?? []).forEach((id) =>
    chips.push({
      key: `c:${id}`,
      text: `Especialidade: ${names.specialty(`c:${id}`) ?? `#${id}`}`,
      kind: 'company',
      value: id
    })
  )
  if (query.withoutSpecialty)
    chips.push({ key: 'e:none', text: 'Sem especialidade', kind: 'no-specialty', value: null })
  return chips
}

export function removeChipFromQuery(query: ListFiltersRequest, chip: SectorSpecialtyChip) {
  if (chip.kind === 'sector' || chip.kind === 'no-sector') {
    return {
      sector: {
        sectorIds: (query.sectorIds ?? []).filter(
          (id) => chip.kind !== 'sector' || id !== chip.value
        ),
        withoutSector: chip.kind === 'no-sector' ? false : !!query.withoutSector
      }
    }
  }
  return {
    specialty: {
      specialtyIds: (query.specialtyIds ?? []).filter(
        (id) => chip.kind !== 'official' || id !== chip.value
      ),
      companySpecialtyIds: (query.companySpecialtyIds ?? []).filter(
        (id) => chip.kind !== 'company' || id !== chip.value
      ),
      withoutSpecialty: chip.kind === 'no-specialty' ? false : !!query.withoutSpecialty
    }
  }
}
